import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { PerfilUserPresenter } from "../presenter/perfil-user.presenter";
import { UsuarioService } from '../../../../services/usuario.service';
import { PerfilForm } from "../../../../interfaces/perfil-form.interface";



@Injectable({
  providedIn: 'root'
})
export class PerfilUserInteractor {


 private _presenter: PerfilUserPresenter;

constructor(private usuarioService: UsuarioService){}

setPresenter(presenter: PerfilUserPresenter):void{
this._presenter = presenter;
}


 updatePerfil(perfilForm: PerfilForm) {
   this.usuarioService.updatePerfil(perfilForm)
               .subscribe(
                  (resp: any) => {
                    this._presenter.isRequestComplete(resp.ok);
                    this._presenter.isEditedResponse(resp);
                  },
                 (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
                );
  }

updatePasword(data: any): void {
   this.usuarioService.updatePasword(data)
               .subscribe(
                  (resp: any) => {
                    this._presenter.isUpdatedPasswordResponse(resp);
                  },
                 (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
                );
}


}
